import axios from "axios";
import { configSettings } from "../config/configSettings";

const api = axios.create({
  baseURL: configSettings.appURL + '/api/v1',
  // baseURL: configSettings.appURL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration and invalid tokens
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;

    // Handle 401 Unauthorized errors (expired or invalid token)
    if (response && response.status === 401) {
      // Clear authentication data
      localStorage.removeItem('token');
      localStorage.removeItem('employeeId');
      localStorage.removeItem('firstName');
      localStorage.removeItem('lastName');
      localStorage.removeItem('empCompanyId');
      localStorage.removeItem('empRoleId');
      localStorage.removeItem('empRoleName');
      localStorage.removeItem('empEmailId');
      
      // Mark that user was logged out due to token expiration
      localStorage.setItem('tokenExpired', 'true');
      
      // Dispatch custom event for logout
      const event = new CustomEvent('tokenExpired', {
        detail: { message: response.data?.message || 'Session expired. Please login again.' }
      });
      window.dispatchEvent(event);

      // Redirect to login page
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
